import * as ActionTypes from "../ActionTypes.js";
import { getFoundHistory } from "../actions/FoundHistoryActions.js";
import { getLost } from "../actions/LostActions.js";
import { toast } from "react-toastify";
import { getServerDomain, toastOptions } from "utils";

export const getClaims = (dispatch) => {
  return fetch(getServerDomain() + "/claimrequests", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) =>
      dispatch({ type: ActionTypes.GET_CLAIMS, payload: response })
    )
    .catch((error) => {
      console.log("Get Claim Requests ", error.message);
      toast.error(
        "Could not get claim requests " + error.message,
        toastOptions
      );
    });
};

export const claim = (dispatch, ids) => {
  return fetch(
    getServerDomain() + "/founditems/" + ids.foundItemId + "/claim",
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  )
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error(response.err, toastOptions);
      } else {
        getClaims(dispatch);
        toast.success("Claim request sent", toastOptions);
      }
    })
    .catch((error) => {
      console.log("Claim ", error.message);
      toast.error("Could not claim the item. " + error.message, toastOptions);
    });
};

export const unClaim = (dispatch, ids) => {
  return fetch(
    getServerDomain() +
      "/claimrequests/" +
      ids.claimerUsername +
      "&" +
      ids.foundItemId +
      "/delete",
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  )
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error(response.err, toastOptions);
      } else {
        toast.success("Claim request took back!", toastOptions);
        dispatch({ type: ActionTypes.UNCLAIM, payload: ids });
      }
    })
    .catch((error) => {
      console.log("unclaim ", error.message);
      toast.error("Could not unclaim the item. " + error.message, toastOptions);
    });
};

export const approveClaim = (dispatch, history, ids) => {
  return fetch(
    getServerDomain() +
      "/claimrequests/" +
      ids.claimerUsername +
      "&" +
      ids.foundItemId +
      "/approve",
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  )
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error(response.err, toastOptions);
      } else {
        history.push("/claimrequests/");
        getLost(dispatch);
        getClaims(dispatch);
        getFoundHistory(dispatch);
        toast.success(
          "Request approved! you can hand  over the item.",
          toastOptions
        );
      }
    })
    .catch((error) => {
      console.log("Approve ", error.message);
      toast.error(
        "Could not approve the request. " + error.message,
        toastOptions
      );
    });
};

export const dismissClaim = (dispatch, history, ids) => {
  return fetch(
    getServerDomain() +
      "/claimrequests/" +
      ids.claimerUsername +
      "&" +
      ids.foundItemId +
      "/delete",
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  )
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error(response.err, toastOptions);
      } else {
        history.push("/claimrequests/");
        toast.success("Request dismissed!", toastOptions);
        dispatch({ type: ActionTypes.UNCLAIM, payload: ids });
      }
    })
    .catch((error) => {
      console.log("dismiss ", error.message);
      toast.error(
        "Could not dismiss the request. " + error.message,
        toastOptions
      );
    });
};
